import { render, staticRenderFns } from "./pop_content.vue?vue&type=template&id=6460c94a&"
import script from "./pop_content.vue?vue&type=script&lang=js&"
export * from "./pop_content.vue?vue&type=script&lang=js&"
import style0 from "./pop_content.vue?vue&type=style&index=0&id=6460c94a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports